import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "components/ui/accordion";

const FAQSection = ({ info = [] }) => {
  return (
    <section className="py-20 bg-cargo-light">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-foreground text-center mb-12 animate-fade-up">
          Түгээмэл асуулт хариулт
        </h2>

        <div className="max-w-2xl mx-auto animate-fade-up delay-200">
          <Accordion type="single" collapsible className="space-y-3">
            {info.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border rounded-lg px-6 overflow-hidden"
              >
                <AccordionTrigger className="text-foreground font-semibold hover:text-primary py-5">
                  {faq.name}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5">
                  {faq.description}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
